import AvailableReceiptsBlock from './AvailableReceiptsBlock';

export default AvailableReceiptsBlock;
